module.exports = __webpack_public_path__ + "static/img/2023年历-6.859666b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-6.jpg
// module id = /DUL
// module chunks = 3